module.exports = __webpack_public_path__ + "h5/img/ava1 (3).c8c1ce08.png";